<template>
  <v-toolbar :color="ui.cardColor">
    <v-toolbar-title :class="ui.textSubheadingBold">
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon> person </v-icon>
        </v-avatar>
        {{this.getUser.basic.title}}
      </v-chip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <StatsReadCard :data="{tag: this.getDetail.basic.tag}"/>
    <UserLaunch/>
  </v-toolbar>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import StatsReadCard from "@/support/stats/components/StatsReadCard";
// import StatsCounters from "@/support/stats/components/StatsCounters";
import UserLaunch from "@/user/user/components/UserLaunch";
import { mapGetters } from "vuex";

export default {
  components: {
    StatsReadCard,
    UserLaunch
  },
  computed: {
    ...mapGetters(["getDetail", "getUser"]),
    stats() {
      return this.getUser.stats;
    }
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
